module.exports = __webpack_public_path__ + "img/dep_petfoodandcare.281c9000.png";